<template>
  <div>
    <FaPageHeader title="欢迎使用代理管理系统" />
    <FaPageMain>
      <template #title>
        首页
      </template>
      首页内容
    </FaPageMain>
  </div>
</template>
